import styled from 'styled-components';
// import * as constant from "../../../src/constant";

export const RegisterStyle = styled.div`
   
   .page-section{
        min-height:600px;
   }
`;
